
import { Vue, Component } from "vue-property-decorator"
import api from "../honcierge-api"
import EditPostscript from "@/components/EditPostscript.vue"

import { DataTableHeader } from "vuetify/types"
import { Postscript } from "types/postscript"

@Component({
  components: { EditPostscript },
})
export default class Postscripts extends Vue {
  private loading = true
  private dialog = false
  private postscripts: Postscript["data"][] = []

  get headers(): DataTableHeader[] {
    return [
      { text: "警告レベル", value: "alertLevelJp" },
      { text: "分類", value: "category" },
      { text: "誤ったテキスト", value: "invalidText" },
      { text: "正しいテキスト", value: "validText" },
      { text: "説明", value: "description" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public created(): void {
    this.loading = false

    this.getPostscripts()
  }

  private getPostscripts() {
    api
      .getPostscripts()
      .then((res) => {
        this.postscripts = res.data.postscripts
      })
      .catch(() => {
        this.$toasted.error("定義一覧の取得に失敗しました")
      })
  }

  private updatePostscript() {
    api
      .getPostscripts()
      .then((res) => {
        this.postscripts = res.data.postscripts
      })
      .catch(() => {
        this.$toasted.error("定義一覧の取得に失敗しました")
      })
    this.close()
  }

  private open(item?: Postscript["data"]) {
    const editPostscript = this.$refs.editPostscript as InstanceType<
      typeof EditPostscript
    >
    if (item) {
      // 更新
      editPostscript.id = item.id
      editPostscript.alertLevel = item.alertLevel
      editPostscript.alertLevelJp = item.alertLevelJp
      editPostscript.category = item.category
      editPostscript.invalidText = item.invalidText
      editPostscript.validText = item.validText
      editPostscript.description = item.description
    } else {
      // 新規作成
      editPostscript.id = -1
    }

    this.dialog = true
  }

  private close() {
    this.dialog = false
  }
}
